import React from "react";

const NoMatch = () => {
    return (
        <div>
            <h1>Bad Request ...</h1>
        </div>
    );
};

export default NoMatch;
